// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__gzQno","header":"ReportDetails_header__kRrid","title":"ReportDetails_title__2_WkA","left":"ReportDetails_left__1psbY"};